module.exports = __webpack_public_path__ + "static/media/StockIcon.d7743702.svg";